// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610052005/js/" + chunkId + "." + {"44":"a56e0b0c","225":"c29c5e01","481":"5b6655e8","486":"d7496780","770":"f3d09f66"}[chunkId] + ".0.14318664035578077.chunk.js";
};